export const flattenTree = (nodes, expandedIds, getNodeKey, level = 0, result = []) => {
    if (!nodes || !Array.isArray(nodes)) {
        return result;
    }

    nodes.forEach(node => {

        const flatNode = {
            ...node,
            level,
            hasChildren: Boolean(node.children && node.children.length > 0) || node.hasChildren,
        };

        result.push(flatNode);

        // Recursively add children if node is expanded
        const nodeKey = getNodeKey(node);
        if (expandedIds.has(nodeKey) && node.children && node.children.length > 0) {
            flattenTree(node.children, expandedIds, getNodeKey, level + 1, result);
        }
    });

    return result;
};

export const buildNodeMap = (nodes, getNodeKey, map = {}) => {
    if (!nodes || !Array.isArray(nodes)) {
        return map;
    }

    nodes.forEach(node => {
        const nodeKey = getNodeKey(node);
        map[nodeKey] = node;

        // Recursively add children
        if (node.children && node.children.length > 0) {
            buildNodeMap(node.children, getNodeKey, map);
        }
    });

    return map;
};

export const filterNodes = (nodes, searchTerm, filterFunction) => {
    if (!searchTerm) {
        return nodes;
    }

    return nodes.filter(node => filterFunction(node, searchTerm));
};

export const filterTreeByTypes = (nodes, hiddenTypes = []) => {
    if (!nodes || !Array.isArray(nodes) || hiddenTypes.length === 0) {
        return nodes;
    }

    return nodes.reduce((acc, node) => {
        // Skip hidden types
        if (hiddenTypes.includes(node.type)) {
            return acc;
        }

        // Recursively filter children
        const filteredNode = {
            ...node,
            children: node.children ? filterTreeByTypes(node.children, hiddenTypes) : [],
        };

        acc.push(filteredNode);
        return acc;
    }, []);
};
